(() => {
  const normalize = (value) => String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  const params = new URLSearchParams(window.location.search);
  const previewControlsEnabled = params.get("preview_controls") === "1";

  function metaobjectDealers() {
    const source = document.querySelector("[data-euphree-dealer-metaobjects]");
    if (!source) return [];
    try {
      const records = JSON.parse(source.textContent);
      return Array.isArray(records) ? records : [];
    } catch {
      return [];
    }
  }

  function dealerRecords() {
    return metaobjectDealers();
  }

  function findDealer(dealers) {
    const dealerId = normalize(params.get("dealer"));
    if (dealerId) return dealers.find((dealer) => normalize(dealer.key) === dealerId);

    const adsetName = normalize(params.get("utm_term"));
    if (adsetName) {
      const adsetMatches = dealers.filter((dealer) =>
        dealer.campaignEnabled === true &&
        normalize(dealer.adsetName) === adsetName
      );
      if (adsetMatches.length === 1) return adsetMatches[0];
    }

    const metaAdsetId = String(params.get("meta_adset_id") || "").trim();
    const googleAdgroupId = String(params.get("google_adgroup_id") || "").trim();
    if (Boolean(metaAdsetId) === Boolean(googleAdgroupId)) return null;

    const routeId = metaAdsetId || googleAdgroupId;
    const routeField = metaAdsetId ? "metaAdsetIds" : "googleAdgroupIds";
    if (!/^\d{5,25}$/.test(routeId)) return null;

    const matches = dealers.filter((dealer) =>
      dealer.campaignEnabled === true &&
      Array.isArray(dealer[routeField]) &&
      dealer[routeField].some((id) => String(id).trim() === routeId)
    );
    return matches.length === 1 ? matches[0] : null;
  }

  function fallbackToStandardProduct() {
    const fallbackUrl = new URL(window.location.href);
    ["view", "dealer", "meta_adset_id", "google_adgroup_id", "adset", "zip", "preview_controls"].forEach((name) => fallbackUrl.searchParams.delete(name));
    window.location.replace(`${fallbackUrl.pathname}${fallbackUrl.search}${fallbackUrl.hash}`);
  }

  function hubSpotLoader() {
    if (window.hbspt?.forms) return Promise.resolve();
    if (window.EuphreeHubSpotLoader) return window.EuphreeHubSpotLoader;
    window.EuphreeHubSpotLoader = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[src*="js.hsforms.net/forms/embed/v2.js"]');
      if (existing) {
        existing.addEventListener("load", resolve, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }
      const script = document.createElement("script");
      script.src = "https://js.hsforms.net/forms/embed/v2.js";
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.append(script);
    });
    return window.EuphreeHubSpotLoader;
  }

  function init(root) {
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    const dealers = dealerRecords();
    const productTitle = root.dataset.productTitle || "this Euphree bike";
    const one = (selector) => root.querySelector(selector);
    const all = (selector) => [...root.querySelectorAll(selector)];
    let hubspotFormRoot = null;

    const setText = (selector, value) => all(selector).forEach((node) => { node.textContent = value; });

    function formValues(dealer) {
      return {
        dealer_key: dealer.key,
        dealer_name: dealer.name,
        dealer_branch_name: dealer.branch,
        dealer_adset_name: dealer.adsetName,
        utm_source: params.get("utm_source") || "",
        utm_medium: params.get("utm_medium") || "",
        utm_campaign: params.get("utm_campaign") || "",
        utm_content: params.get("utm_content") || "",
        test_ride_landing_page_url: landingPageUrl(),
        bike_you_want_to_take_for_a_spin: productTitle
      };
    }

    function landingPageUrl() {
      const url = new URL(window.location.href);
      [
        "dealer_key",
        "dealer_name",
        "dealer_branch_name",
        "dealer_adset_name",
        "test_ride_landing_page_url",
        "bike_you_want_to_take_for_a_spin"
      ].forEach((name) => url.searchParams.delete(name));
      return url.toString();
    }

    function setFormValues(dealer, formRoot = hubspotFormRoot) {
      const values = formValues(dealer);

      const assignValue = (field, value) => {
        const fieldWindow = field.ownerDocument?.defaultView || window;
        const prototype = field.tagName === "SELECT"
          ? fieldWindow.HTMLSelectElement?.prototype
          : fieldWindow.HTMLInputElement?.prototype;
        const nativeSetter = prototype && Object.getOwnPropertyDescriptor(prototype, "value")?.set;
        if (nativeSetter) nativeSetter.call(field, String(value || ""));
        else field.value = String(value || "");
        field.dispatchEvent(new fieldWindow.Event("input", { bubbles: true }));
        field.dispatchEvent(new fieldWindow.Event("change", { bubbles: true }));
      };

      Object.entries(values).forEach(([name, value]) => {
        const previewField = root.querySelector(`[data-field="${name}"]`);
        if (previewField) previewField.value = String(value || "");
        const jqueryField = typeof formRoot?.find === "function" ? formRoot.find(`[name="${name}"]`) : null;
        if (jqueryField?.length) jqueryField.val(String(value || "")).trigger("input").trigger("change");
        const formElement = formRoot?.querySelector ? formRoot : formRoot?.[0];
        const liveField = formElement?.querySelector?.(`[name="${name}"]`);
        if (liveField) assignValue(liveField, value);
      });
    }

    function setSubmissionValues(dealer, submissionValues) {
      if (!Array.isArray(submissionValues)) return;
      Object.entries(formValues(dealer)).forEach(([name, value]) => {
        const submittedField = submissionValues.find((field) => field.name === name || field.name?.endsWith(`/${name}`));
        if (submittedField) submittedField.value = String(value || "");
        else submissionValues.push({ name, value: String(value || "") });
      });
    }

    function render(dealer) {
      if (!dealer) return;
      setText("[data-dealer-display]", dealer.displayName);
      setText("[data-dealer-summary]", dealer.dealerSummary || `${dealer.displayName} serves riders in ${dealer.city}, ${dealer.state}, and nearby communities.`);
      setText("[data-dealer-profile]", dealer.dealerProfile || `Meet your local Euphree dealer in ${dealer.city}. Use the form to confirm current inventory and test-ride availability.`);
      setText("[data-visual-title]", `Ride the ${productTitle} in ${dealer.city}`);
      setText("[data-visual-dealer]", dealer.displayName);

      const image = one("[data-dealer-image]");
      image.src = dealer.heroImage;
      image.alt = dealer.heroImageAlt || `Euphree electric bikes near ${dealer.city}, ${dealer.state}`;

      const hasAddress = Boolean(dealer.streetAddress);
      setText("[data-address-label]", hasAddress ? "Address" : "Service area");
      setText("[data-dealer-address]", hasAddress ? dealer.streetAddress : `${dealer.city}, ${dealer.state} ${dealer.baseZip}`);
      const phoneRow = one("[data-phone-row]");
      phoneRow.hidden = !dealer.phone;
      if (dealer.phone) {
        const phone = one("[data-dealer-phone]");
        phone.href = `tel:${dealer.phone}`;
        phone.textContent = dealer.phoneDisplay || dealer.phone;
      }

      const hoursList = one("[data-dealer-hours]");
      hoursList.replaceChildren();
      (dealer.hours?.length ? dealer.hours : [["Hours", "Confirm when scheduling"]]).forEach(([day, time]) => {
        const item = document.createElement("li");
        const dayLabel = document.createElement("span");
        const timeLabel = document.createElement("strong");
        dayLabel.textContent = day;
        timeLabel.textContent = time;
        item.append(dayLabel, timeLabel);
        hoursList.append(item);
      });

      const mapQuery = encodeURIComponent(dealer.mapsPlaceId ? dealer.mapsQuery : (dealer.streetAddress || dealer.mapsQuery || `${dealer.city}, ${dealer.state}`));
      const placeId = dealer.mapsPlaceId ? `&query_place_id=${encodeURIComponent(dealer.mapsPlaceId)}` : "";
      const mapUrl = `https://www.google.com/maps/search/?api=1&query=${mapQuery}${placeId}`;
      one("[data-dealer-map]").src = `https://www.google.com/maps?q=${mapQuery}&output=embed`;
      one("[data-map-link]").href = mapUrl;
      const directions = one("[data-directions-link]");
      directions.href = dealer.mapsPlaceId
        ? `https://www.google.com/maps/dir/?api=1&destination=${mapQuery}&destination_place_id=${encodeURIComponent(dealer.mapsPlaceId)}`
        : mapUrl;
      directions.textContent = hasAddress ? "Get Directions" : "View Dealer Area";
      setText("[data-data-note]", dealer.dataNote || "Confirm current hours and test-ride availability with the dealer.");

      setFormValues(dealer);
    }

    function configurePreviewControls(activeDealer) {
      const controls = one("[data-preview-controls]");
      const select = one("[data-preview-dealer-select]");
      if (!previewControlsEnabled || !controls || !select) return;

      [...dealers]
        .sort((first, second) => `${first.state || ""} ${first.displayName || ""}`.localeCompare(`${second.state || ""} ${second.displayName || ""}`))
        .forEach((dealer) => {
          const option = document.createElement("option");
          option.value = dealer.key;
          option.textContent = [dealer.state, dealer.displayName].filter(Boolean).join(" — ");
          select.append(option);
        });

      select.value = activeDealer.key;
      setText("[data-preview-dealer-count]", `${dealers.length} dealer locations loaded`);
      controls.hidden = false;

      select.addEventListener("change", () => {
        const selectedDealer = dealers.find((dealer) => dealer.key === select.value);
        if (!selectedDealer) return;
        const previewUrl = new URL(window.location.href);
        previewUrl.searchParams.set("dealer", selectedDealer.key);
        previewUrl.searchParams.delete("utm_content");
        previewUrl.searchParams.delete("adset");
        previewUrl.searchParams.delete("meta_adset_id");
        previewUrl.searchParams.delete("google_adgroup_id");
        previewUrl.searchParams.delete("zip");
        previewUrl.searchParams.set("preview_controls", "1");
        window.location.assign(previewUrl.toString());
      });
    }

    function connectHubSpot(activeDealer) {
      const config = window.EUPHREE_HUBSPOT_CONFIG || {};
      const status = one("[data-hubspot-status]");
      if (!config.portalId || !config.formId) {
        status.textContent = "HubSpot configuration needed";
        return;
      }
      hubSpotLoader().then(() => {
        window.hbspt.forms.create({
          region: config.region || "na1",
          portalId: config.portalId,
          formId: config.formId,
          target: `#${one("[data-hubspot-form]").id}`,
          onFormReady: (form) => {
            hubspotFormRoot = form;
            one("[data-preview-form]").hidden = true;
            setFormValues(activeDealer, form);
            form?.addEventListener?.("submit", () => setFormValues(activeDealer, form), true);
          },
          onBeforeFormSubmit: (form, submissionValues) => {
            setFormValues(activeDealer, form);
            setSubmissionValues(activeDealer, submissionValues);
          }
        });
      }).catch(() => {
        status.textContent = "HubSpot could not load";
      });
    }

    if (!dealers.length) {
      fallbackToStandardProduct();
      return;
    }

    const activeDealer = findDealer(dealers);
    if (!activeDealer) {
      fallbackToStandardProduct();
      return;
    }
    configurePreviewControls(activeDealer);
    render(activeDealer);
    one("[data-preview-form]").addEventListener("submit", (event) => {
      event.preventDefault();
      setText("[data-preview-message]", `HubSpot is still loading. Your request has not been submitted.`);
    });
    connectHubSpot(activeDealer);
  }

  document.querySelectorAll("[data-dealer-test-ride-pdp]").forEach(init);
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll?.("[data-dealer-test-ride-pdp]").forEach(init);
  });
})();
